import { Form } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import FieldError from '../../../../shared/fields-errors/field-error';

function ProgramFees(props) {
    const { register, formState:{errors}, watch } = useFormContext();
    const fieldsWatcher = watch();

    return (
        <>
            <div className='main-form-wrapper'>
                <h6 className="mb-3 text-black fw-bold">
                    <i className="fa-solid fa-dollar-sign text-primary me-2"></i>
                    Fees
                </h6>
                <p className='text-muted f-12-small'>Set the pricing and payment options for this program. Choose whether registration is free or paid, define the fee structure, and connect available payment methods.</p>

                {/* Fee Type Section */}
                <div className='row mb-3'>
                    <div className='col-xxl-12 col-md-12'>
                        <Form.Group className="mb-3">
                            <Form.Label className='text-bold text-black'>
                                <span className='text-danger'>*</span> Fee Type
                            </Form.Label>
                            <Form.Select
                                {...register("pricing.fee_type", {
                                    required: {
                                        value: true,
                                        message: "This field is required"
                                    }
                                })}
                            >
                                <option value="free">Free</option>
                                <option value="paid">Paid</option>
                            </Form.Select>
                            {errors?.pricing?.fee_type ? <FieldError message={errors?.pricing?.fee_type?.message} /> : ''}
                        </Form.Group>
                    </div>
                </div>

                {
                    fieldsWatcher?.pricing?.fee_type === 'paid' ?
                    <>
                    {/* Payment Options Checkboxes */}
                <div className='row mb-3'>
                    <div className='col-xxl-12 col-md-12'>
                        <label className='d-flex align-items-center'>
                            <input className='me-1'
                            {...register("pricing.enable_apple_google_pay")}
                            type="checkbox"
                        /> Enable Apple & Google Pay
                        </label>
                        <p className='text-muted f-12-small ms-4'>Allow registrants to speed through checkout in just a few clicks using Apple Pay, Google Pay.</p>
                    </div>
                </div>

                {/* <div className='row mb-3'>
                    <div className='col-xxl-12 col-md-12'>
                        <label className='d-flex align-items-center'>
                            <input className='me-1'
                            type="checkbox"
                            {...register("pricing.ask_cover_transaction_fees")}
                        /> Ask registrants to cover transaction fees
                        </label>
                        <p className='text-muted f-12-small ms-4'>Give registrants the option to add transaction fees to their payment total.</p>
                    </div>
                </div>

                <div className='row mb-3'>
                    <div className='col-xxl-12 col-md-12'>
                        <label className='d-flex align-items-center'>
                            <input className='me-1'
                            type="checkbox"
                            {...register("pricing.include_processing_fees_default")}
                        /> Include processing fees by default
                        </label>
                        <p className='text-muted f-12-small ms-4'>Automatically adds transaction fees to the total unless the registrant opts out.</p>
                    </div>
                </div> */}

                {/* Pricing Model Section */}
                <div className='main-form-wrapper mb-3'>
                    <h6 className='mb-3 fw-bold'>Pricing Model</h6>
                    <hr className='m-2' />
                    <p className='text-muted f-12-small'>Define how fees are structured and billed. Choose one-time or recurring options and specify whether fees apply per registration or per participant.</p>

                    {/* Fee Calculation */}
                    <div className='row mb-3'>
                        <div className='col-xxl-12 col-md-12'>
                            <Form.Label className='text-bold text-black'>
                                <span className='text-danger'>*</span> Fee Calculation
                            </Form.Label>
                            <div className='d-flex gap-4'>
                                <label className='d-flex align-items-center'>
                                    <input className='me-1'
                                    {...register("pricing.fee_calculation", {
                                        required: {
                                            value: true,
                                            message: "This field is required"
                                        }
                                    })}
                                    type="radio"
                                    value="per_registration"
                                /> Per Registration
                                </label>
                                <label className='d-flex align-items-center'>
                                    <input className='me-1'
                                    {...register("pricing.fee_calculation", {
                                        required: {
                                            value: true,
                                            message: "This field is required"
                                        }
                                    })}
                                    type="radio"
                                    value="per_participant"
                                /> Per Participant
                                </label>
                            </div>
                            {errors?.pricing?.fee_calculation ? <FieldError message={errors?.pricing?.fee_calculation?.message} /> : ''}
                        </div>
                    </div>

                    {/* Pricing Option */}
                    <div className='row mb-3'>
                        <div className='col-xxl-12 col-md-12'>
                            <Form.Label className='text-bold text-black'>
                                <span className='text-danger'>*</span> Pricing Option
                            </Form.Label>
                            <div className='d-flex gap-4'>
                                <label className='d-flex align-items-center'>
                                    <input className='me-1'
                                    {...register("pricing.enable_one_time_payment", {
                                        required: {
                                            value: !fieldsWatcher?.pricing?.enable_monthly_payment && !fieldsWatcher?.pricing?.enable_one_time_payment,
                                            message: "Select at-least one option"
                                        }
                                    })}
                                    type="checkbox"
                                /> One-Time Payment
                                </label>
                                <label className='d-flex align-items-center'>
                                    <input className='me-1'
                                    {...register("pricing.enable_monthly_payment", {
                                         required: {
                                            value: !fieldsWatcher?.pricing?.enable_monthly_payment && !fieldsWatcher?.pricing?.enable_one_time_payment,
                                            message: "Select at-least one option"
                                        }
                                    })}
                                    type="checkbox"
                                /> Monthly Payment
                                </label>
                            </div>
                            {(errors?.pricing?.enable_one_time_payment || errors?.pricing?.enable_monthly_payment) ? 
                            <FieldError message={
                                errors?.pricing?.enable_one_time_payment?.message || errors?.pricing?.enable_monthly_payment?.message
                            } /> : ''}
                        </div>
                    </div>

                    {/* Default Option */}
                    <div className='row mb-3'>
                        <div className='col-xxl-4 col-md-12'>
                            <Form.Group className="mb-3">
                                <Form.Label className='text-bold text-black'>Default Option</Form.Label>
                                <Form.Select
                                    {...register("pricing.payment_settings.default_payment_option")}
                                >
                                    <option value="one_time">One-Time</option>
                                    <option value="monthly">Monthly</option>
                                </Form.Select>
                            </Form.Group>
                        </div>
                        <div className='col-xxl-4 col-md-12'>
                            <Form.Group className="mb-3">
                                <Form.Label className='text-bold text-black'>Recurring Option</Form.Label>
                                <Form.Select {...register("pricing.payment_settings.recurring_payment_end_type")}>
                                    <option value='program_end'>End by Date</option>
                                </Form.Select>
                            </Form.Group>
                        </div>
                        <div className='col-xxl-4 col-md-12'>
                            <Form.Group className="mb-3">
                                <Form.Label className='text-bold text-black'><span className='text-danger'>*</span>Select End by Date</Form.Label>
                                <Form.Control {...register("pricing.payment_settings.recurring_payment_end_date", {
                                    required:{
                                        value: true,
                                        message: "This field is required"
                                    },
                                    validate: val => new Date(val).setHours(0,0,0,0) > new Date().setHours(0,0,0,0) || "Start date must be greater then from today"
                                })} type="date" />
                                {errors?.pricing?.payment_settings?.recurring_payment_end_date ? <FieldError message={errors?.pricing?.payment_settings?.recurring_payment_end_date?.message} /> : ''}
                            </Form.Group>
                        </div>
                    </div>
                </div>

                {/* Amounts Section */}
                <div className='main-form-wrapper mb-3'>
                    <h6 className='mb-3 fw-bold'>Amounts</h6>
                    <hr className='m-2' />
                    <p className='text-muted f-12-small'>Enter the base amounts for one-time and recurring payments. These will appear as options during checkout.</p>

                    <div className='row mb-3'>
                        <div className='col-xxl-6 col-md-12'>
                            <Form.Group className="mb-3">
                                <Form.Label className='text-bold text-black'>One-Time Payment Amount</Form.Label>
                                <Form.Control {...register("pricing.one_time_amount", {
                                    valueAsNumber: true,
                                      validate: (v) => {
                                                const num = Number(v);
                                                if(num <= 0){
                                                    return "Amount must be greater than 0"
                                                }else if(num === fieldsWatcher?.pricing?.monthly_amount){
                                                    return "Monthly and One-Time amount cannot be same"
                                                }

                                                return true;
                                            }
                                })} type="number" placeholder="0.00" />
                                {errors?.pricing?.one_time_amount ? <FieldError message={errors?.pricing?.one_time_amount?.message} /> : ''}
                            </Form.Group>
                        </div>
                        <div className='col-xxl-6 col-md-12'>
                            <Form.Group className="mb-3">
                                <Form.Label className='text-bold text-black'>Monthly Recurring Amount</Form.Label>
                                <Form.Control {...register("pricing.monthly_amount", {
                                    valueAsNumber: true,
                                    validate: (v) => {
                                                const num = Number(v);
                                                if(num <= 0){
                                                    return "Amount must be greater than 0"
                                                }else if(num === fieldsWatcher?.pricing?.one_time_amount){
                                                    return "Monthly and One-Time amount cannot be same"
                                                }

                                                return true;
                                            }
                                })} type="number" placeholder="0.00" />
                                {errors?.pricing?.monthly_amount ? <FieldError message={errors?.pricing?.monthly_amount?.message} /> : ''}
                            </Form.Group>
                        </div>
                    </div>

                    <div className='row mb-3'>
                        <div className='col-xxl-6 col-md-12'>
                            <Form.Group className="mb-3">
                                <Form.Label className='text-bold text-black'>One-Time Description</Form.Label>
                                <Form.Control
                                    {...register("pricing.payment_settings.one_time_description")}
                                    type="text"
                                    placeholder="Enter description"
                                />
                            </Form.Group>
                        </div>
                        <div className='col-xxl-6 col-md-12'>
                            <Form.Group className="mb-3">
                                <Form.Label className='text-bold text-black'>Monthly Description</Form.Label>
                                <Form.Control
                                    type="text"
                                    {...register("pricing.payment_settings.monthly_description")}
                                    placeholder="Enter description"
                                />
                            </Form.Group>
                        </div>
                    </div>
                </div>

                {/* Additional Participants Section */}
                <div className='main-form-wrapper'>
                    <h6 className='mb-3 fw-bold'>Additional Participants</h6>
                    <hr className='m-2' />
                    <p className='text-muted f-12-small'>Add optional discounted amount for multiple participants (e.g., first child full price, additional children discounted).</p>

                    <div className='row'>
                        <div className='col-xxl-6 col-md-12'>
                            <Form.Group className="mb-3">
                                <Form.Label className='text-bold text-black'>One-Time Payment Amount</Form.Label>
                                <Form.Control
                                    {...register("pricing.additional_participant_one_time", {
                                        valueAsNumber: true,
                                        required:{
                                            value: false
                                        },
                                          validate: (val) => {
                                            if(val){
                                                const num = Number(val);
                                                if(num <= 0){
                                                    return "Amount must be greater than 0"
                                                }else if(num === fieldsWatcher?.pricing?.additional_participant_monthly){
                                                    return "Monthly and One-Time amount cannot be same"
                                                }
                                                return true;
                                            }else{
                                                return true
                                            }
                                            }
                                    })}
                                    type="number" placeholder="0.00" />
                                    {errors?.pricing?.additional_participant_one_time ? <FieldError message={errors?.pricing?.additional_participant_one_time?.message} /> : ''}
                            </Form.Group>
                        </div>
                        <div className='col-xxl-6 col-md-12'>
                            <Form.Group className="mb-3">
                                <Form.Label className='text-bold text-black'>Monthly Recurring Amount</Form.Label>
                                <Form.Control
                                    {...register("pricing.additional_participant_monthly", {
                                        valueAsNumber: true,
                                         validate: (val) => {
                                            if(val){
                                                 const num = Number(val);
                                                if(num <= 0){
                                                    return "Amount must be greater than 0"
                                                }else if(num === fieldsWatcher?.pricing?.additional_participant_one_time){
                                                    return "Monthly and One-Time amount cannot be same"
                                                }
                                                return true;
                                            }else{
                                                return true
                                            }
                                            }
                                    })}
                                    type="number" placeholder="0.00" />
                                    {errors?.pricing?.additional_participant_monthly ? <FieldError message={errors?.pricing?.additional_participant_monthly?.message} /> : ''}
                            </Form.Group>
                        </div>
                    </div>
                </div>
                    </> : <></>
                }
                
            </div>
        </>
    );
}

export default ProgramFees;